import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

// Pages
import { UserAccountPage } from '../../pages/user-account/user-account';

// Providers
import { UsersService } from '../../providers/users/users-service';

@Component({
  selector: 'page-users',
  templateUrl: 'users.html'
})
export class UsersPage {
  headerData: any;

  users: any = [];

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public usersService: UsersService
  ) {
    this.headerData = { title: 'Users' };
  }

  getUsers()
  {
    this.usersService.getUsers().subscribe( data => {
      this.users = data;
    });
  }

  showUserAddEditPage( user )
  {
    this.navCtrl.push( UserAccountPage, {
      user: user,
      context: 'user-manager'
    });
  }

  ionViewDidEnter()
  {
    this.getUsers();
  }
}


// WEBPACK FOOTER //
// ./src/pages/users/users.ts